// src/screens/mypage/MyReviewsScreen.js
// 47차: 스포일러 렌더링 버그 수정 — content/comment 항상 렌더 후 SpoilerText 조건 수정
// 51차: 색 theme.js 단일화 — COLORS 참조 / 탈출성공 초록 통일
// 74차: 데이터 로드를 useEffect(마운트 1회) → useFocusEffect로 변경 — WriteReviewScreen에서
//       돌아왔을 때 방금 쓴 리뷰가 바로 반영되지 않던 문제
// 74차: 화면 자체 커스텀 헤더 → 공통 AppHeader로 교체
// 77차: 74차 교체 시 제목 누락("‹ 뒤로"만 보이던 것 — "AppHeader 없음" 반복 신고 원인) 복원
// 75차: "작성 가능" 계산을 reviewService.getWriteableReservations()로 추출 — MyPageScreen.js
// "내 리뷰" 뱃지와 같은 기준을 쓰게 하기 위함(기존엔 뱃지가 알림 개수를 써서 서로 달랐음)
// 78차: "작성하기"/"작성 완료 리뷰 보기"/"리뷰 작성하러 가기" 버튼(전부 인라인 골드 fill)을
// 공용 GradientButton(Primary)으로 교체 — 77차 버튼 시스템 도입 때 이 화면이 빠져 있었음.

import React, { useState, useEffect, useCallback } from 'react';
import { showAlert } from '../../components/common/AppAlert';
import {
  View, Text, FlatList, TouchableOpacity, StyleSheet,
  ActivityIndicator, ScrollView,
} from 'react-native';
// 78차 37차: 썸네일 캐싱 없이 매번 재다운로드되던 것 — expo-image로 교체(디스크 캐시 자동)
import { Image } from 'expo-image';
import { useFocusEffect } from '@react-navigation/native';
import { Ionicons } from '@expo/vector-icons';
import { getMyReviews, deleteReview, getWriteableReservations } from '../../services/reviewService';
import { getProductById, normalizeProduct } from '../../services/productService';
import { useAuth } from '../../contexts/AuthContext';
import LoadingOverlay from '../../components/common/LoadingOverlay';
import AppHeader from '../../components/common/AppHeader';
import GradientButton from '../../components/common/GradientButton';
import { StarRating, VerifiedBadge, SpoilerText } from '../../components/common/ReviewCard';
import { MenuStoreIcon, MenuReservationIcon, MenuReviewIcon, RewardIcon, IconLabel, ReviewWriteableIcon, ReviewNotWriteableIcon, EscapeRecordSuccessIcon, EscapeRecordFailIcon } from '../../components/common/Icons';
import { LogoMark } from '../../components/common/AppHeader';
import { COLORS } from '../../constants/theme';

const GOLD = COLORS.gold, BG = COLORS.bg, SURFACE = COLORS.surface, SURFACE2 = COLORS.surface2;
const BORDER = COLORS.border, TEXT = COLORS.text;
const TEXT_SEC = COLORS.textSec, TEXT_MUTED = COLORS.textMuted;
const GREEN = COLORS.green, RED = COLORS.red;

const TABS = [
  { key: 'writeable', label: '작성 가능' },
  { key: 'done',      label: '작성 완료' },
];

const thumbCache = {};
async function fetchThumb(productId) {
  if (!productId) return null;
  if (thumbCache[productId] !== undefined) return thumbCache[productId];
  try {
    const p = await getProductById(productId);
    const url = p ? normalizeProduct(p).thumbnailUrl : null;
    thumbCache[productId] = url || null;
    return thumbCache[productId];
  } catch {
    thumbCache[productId] = null;
    return null;
  }
}

function ThumbImage({ productId, style, fallbackStyle }) {
  const [uri, setUri]     = useState(null);
  const [tried, setTried] = useState(false);
  useEffect(() => {
    let cancelled = false;
    fetchThumb(productId).then(url => {
      if (!cancelled) { setUri(url); setTried(true); }
    });
    return () => { cancelled = true; };
  }, [productId]);
  if (!tried) return (
    <View style={[style, fallbackStyle, { justifyContent:'center', alignItems:'center' }]}>
      <ActivityIndicator size="small" color={GOLD} />
    </View>
  );
  if (uri) return <Image source={{ uri }} style={style} />;
  return (
    <View style={[style, fallbackStyle, { justifyContent:'center', alignItems:'center' }]}>
      <LogoMark size={22} />
    </View>
  );
}

// 47차: ReviewContent — 스포일러 조건 분리 수정
function ReviewContent({ item }) {
  const text = item.content || item.comment;
  if (!text) return null;
  if (item.spoiler) {
    return <SpoilerText text={text} style={s.content} />;
  }
  return <Text style={s.content}>{text}</Text>;
}

export default function MyReviewsScreen({ navigation }) {
  const { user } = useAuth();
  const [reviews,   setReviews]   = useState([]);
  const [writeable, setWriteable] = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [tab,       setTab]       = useState('writeable');
  const [loadError, setLoadError] = useState(false);

  // 74차: useEffect(마운트 1회) → useFocusEffect로 변경 — 리뷰 작성 화면에서 돌아왔을 때
  // 새로 쓴 리뷰가 바로 반영되지 않고 다른 화면을 거쳐야만 반영되던 문제
  useFocusEffect(
    useCallback(() => {
      let cancelled = false;
      const loadAll = async () => {
        try {
          setLoadError(false);
          const [myReviews, canWrite] = await Promise.all([
            getMyReviews(user.uid),
            getWriteableReservations(user.uid),
          ]);
          if (cancelled) return;
          setReviews(myReviews);
          setWriteable(canWrite);
          if (canWrite.length === 0) setTab('done');
        } catch { if (!cancelled) setLoadError(true); }
        finally { if (!cancelled) setLoading(false); }
      };
      loadAll();
      return () => { cancelled = true; };
    }, [user.uid])
  );

  // 79차: deleteReview()가 reviewId 하나만 받는데(리뷰 사진은 소프트삭제 정책상 의도적으로
  // 안 지움) 여기서 안 쓰는 imageUrls를 두 번째 인자로 넘기고 있었음 — 죽은 인자 정리.
  const handleDelete = (id) => {
    showAlert('리뷰 삭제', '이 리뷰를 삭제하시겠습니까?', [
      { text:'취소', style:'cancel' },
      { text:'삭제', style:'destructive', onPress: async () => {
        try {
          await deleteReview(id);
          setReviews(prev => prev.filter(r => r.id !== id));
        } catch {
          showAlert('오류', '리뷰 삭제에 실패했어요. 다시 시도해주세요.');
        }
      }},
    ]);
  };

  if (loading) return <LoadingOverlay />;

  return (
    <View style={s.container}>
      <AppHeader showBack centerElement={<Text style={{ color: COLORS.text, fontSize: 15, fontWeight: '800' }}>내 리뷰</Text>} />

      <View style={s.tabRow}>
        {TABS.map(t => (
          <TouchableOpacity
            key={t.key}
            style={[s.tabBtn, tab === t.key && s.tabBtnOn]}
            onPress={() => setTab(t.key)}>
            <Text style={[s.tabTxt, tab === t.key && s.tabTxtOn]}>
              {t.label}
            </Text>
            {t.key === 'writeable' && writeable.length > 0 && (
              <View style={s.tabBadge}>
                <Text style={s.tabBadgeTxt}>{writeable.length}</Text>
              </View>
            )}
            {t.key === 'done' && reviews.length > 0 && (
              <View style={[s.tabBadge, { backgroundColor: SURFACE }]}>
                <Text style={[s.tabBadgeTxt, { color: TEXT_MUTED }]}>{reviews.length}</Text>
              </View>
            )}
          </TouchableOpacity>
        ))}
      </View>

      {tab === 'writeable' && (
        <ScrollView contentContainerStyle={{ padding:16, paddingBottom:40 }}>
          {writeable.length === 0 ? (
            <View style={{ alignItems:'center', marginTop:80, gap:12 }}>
              {loadError ? <ReviewNotWriteableIcon size={64} /> : <ReviewWriteableIcon size={64} />}
              <Text style={{ color:TEXT_MUTED, fontSize:14, fontWeight:'600' }}>
                {loadError ? '리뷰 정보를 불러오지 못했어요' : '작성 가능한 리뷰가 없어요'}
              </Text>
              {!loadError && (
                <Text style={{ color:TEXT_MUTED, fontSize:12, textAlign:'center', lineHeight:18 }}>
                  방탈출 예약 후 이용 날짜가 지나면{'\n'}여기서 리뷰를 작성할 수 있어요
                </Text>
              )}
              {!loadError && (
                <GradientButton label="작성 완료 리뷰 보기" onPress={() => setTab('done')} style={s.ctaBtn} textStyle={s.ctaBtnTxt} />
              )}
            </View>
          ) : (
            writeable.map(r => (
              <View key={r.id} style={s.writeableCard}>
                <View style={s.writeableCardLeft}>
                  <View style={s.thumb}>
                    <ThumbImage
                      productId={r.productId}
                      style={s.thumbImg}
                      fallbackStyle={{ backgroundColor: SURFACE2 }}
                    />
                  </View>
                  <View style={{ flex:1 }}>
                    <Text style={s.writeableTheme} numberOfLines={1}>
                      {r.themeName || r.productName || '테마 정보 없음'}
                    </Text>
                    {r.branchName && (
                      <IconLabel Icon={MenuStoreIcon} size={11} color={TEXT_SEC} textStyle={s.writeableBranch} numberOfLines={1}>{r.branchName}</IconLabel>
                    )}
                    <IconLabel Icon={MenuReservationIcon} size={11} color={TEXT_MUTED} textStyle={s.writeableDate}>{r.date}{r.time ? ` · ${r.time}` : ''}</IconLabel>
                    <View style={s.pointNotice}>
                      <IconLabel Icon={RewardIcon} size={12} color={GOLD} textStyle={s.pointNoticeTxt}>리뷰 작성 시 100P 적립</IconLabel>
                    </View>
                  </View>
                </View>
                <GradientButton
                  label="작성하기"
                  onPress={() => navigation.navigate('WriteReview', {
                    reservationId: r.id,
                    productId:     r.productId,
                    productName:   r.productName || r.themeName,
                    bookingFormat: r.bookingFormat, // 80차 후속: 체험형 공연은 탈출 성공/실패 선택 숨김
                  })}
                />
              </View>
            ))
          )}
        </ScrollView>
      )}

      {tab === 'done' && (
        <FlatList
          data={reviews}
          keyExtractor={i => i.id}
          contentContainerStyle={{ padding:16, paddingBottom:40 }}
          renderItem={({ item }) => (
            <View style={s.card}>
              <View style={s.cardTop}>
                <View style={{ flex:1, gap:4 }}>
                  <View style={{ flexDirection:'row', alignItems:'center', gap:8, flexWrap:'wrap' }}>
                    <StarRating rating={item.rating} />
                    <VerifiedBadge verified={item.verified} />
                  </View>
                  {(item.productName || item.themeName) && (
                    <IconLabel Icon={LogoMark} size={s.reviewTheme.fontSize || 13} color={s.reviewTheme.color} textStyle={s.reviewTheme} numberOfLines={1}>
                      {item.productName || item.themeName}
                    </IconLabel>
                  )}
                </View>
                <Text style={s.date}>{new Date(item.createdAt).toLocaleDateString('ko-KR')}</Text>
              </View>

              {/* 47차: ReviewContent 컴포넌트로 스포일러 처리 분리 */}
              <ReviewContent item={item} />

              {(item.imageUris?.length > 0 || item.imageUrls?.length > 0) && (
                <ScrollView horizontal showsHorizontalScrollIndicator={false} style={s.imageRow}>
                  {(item.imageUris || item.imageUrls || []).map((url, i) => (
                    <Image key={i} source={{ uri:url }} style={s.reviewImg} />
                  ))}
                </ScrollView>
              )}
              <View style={s.cardBottom}>
                {/* 79차: [버그 수정] 리뷰 문서엔 escapeResult/escapeTime이 아니라
                    escapeResult만 저장되는데(addReview 페이로드, ReviewCard.js 렌더 기준),
                    이 화면만 존재한 적 없는 필드명 item.escaped/item.escapeTime을 읽고
                    있어서 항상 undefined라 이 뱃지가 한 번도 렌더된 적이 없었음(전수
                    정독으로 발견) — 같은 리뷰가 테마 상세(ReviewCard)엔 정상 표시됨. */}
                {item.escapeResult != null && (
                  <IconLabel Icon={item.escapeResult ? EscapeRecordSuccessIcon : EscapeRecordFailIcon} size={12}
                    color={item.escapeResult ? GREEN : RED}
                    textStyle={[s.result, { color: item.escapeResult ? GREEN : RED }]}>
                    {item.escapeResult ? '탈출 성공' : '탈출 실패'}
                  </IconLabel>
                )}
                <TouchableOpacity
                  style={s.deleteBtn}
                  onPress={() => handleDelete(item.id)}>
                  <Ionicons name="trash-outline" size={16} color={RED} />
                  <Text style={s.deleteBtnText}>삭제</Text>
                </TouchableOpacity>
              </View>
            </View>
          )}
          ListEmptyComponent={
            <View style={{ alignItems:'center', marginTop:80, gap:12 }}>
              <MenuReviewIcon size={40} color={TEXT_MUTED} />
              <Text style={{ color:TEXT_MUTED, fontSize:14 }}>
                {loadError ? '리뷰 정보를 불러오지 못했어요' : '작성한 리뷰가 없어요'}
              </Text>
              {!loadError && writeable.length > 0 && (
                <GradientButton label="리뷰 작성하러 가기" onPress={() => setTab('writeable')} style={s.ctaBtn} textStyle={s.ctaBtnTxt} />
              )}
            </View>
          }
        />
      )}
    </View>
  );
}

const s = StyleSheet.create({
  container:   { flex:1, backgroundColor:BG },

  tabRow:     {
    flexDirection:'row', backgroundColor:SURFACE,
    borderBottomWidth:1, borderBottomColor:BORDER,
  },
  tabBtn:     {
    flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center',
    gap:6, paddingVertical:13,
    borderBottomWidth:2, borderBottomColor:'transparent',
  },
  tabBtnOn:   { borderBottomColor:GOLD },
  tabTxt:     { color:TEXT_MUTED, fontSize:13, fontWeight:'600' },
  tabTxtOn:   { color:GOLD, fontWeight:'800' },
  tabBadge:   {
    backgroundColor:GOLD, borderRadius:10, minWidth:20, height:20,
    alignItems:'center', justifyContent:'center', paddingHorizontal:6,
  },
  tabBadgeTxt:{ color:BG, fontSize:11, fontWeight:'900' },

  writeableCard:     {
    backgroundColor:SURFACE, borderRadius:14, padding:14,
    marginBottom:12, borderWidth:1, borderColor:GOLD+'40',
  },
  writeableCardLeft: { flexDirection:'row', gap:12, marginBottom:12 },
  thumb:             { width:64, height:64, borderRadius:10, overflow:'hidden', flexShrink:0 },
  thumbImg:          { width:64, height:64 },
  writeableTheme:    { color:TEXT, fontSize:14, fontWeight:'700', marginBottom:3 },
  writeableBranch:   { color:TEXT_SEC, fontSize:12, marginBottom:3 },
  writeableDate:     { color:TEXT_MUTED, fontSize:11, marginBottom:6 },
  pointNotice:       {
    backgroundColor:GOLD+'15', borderRadius:6, paddingHorizontal:8,
    paddingVertical:4, borderWidth:1, borderColor:GOLD+'35', alignSelf:'flex-start',
  },
  pointNoticeTxt:    { color:GOLD, fontSize:11, fontWeight:'600' },

  card:       {
    backgroundColor:SURFACE, borderRadius:12, padding:16,
    marginBottom:12, borderWidth:1, borderColor:BORDER,
  },
  cardTop:    {
    flexDirection:'row', justifyContent:'space-between',
    alignItems:'flex-start', marginBottom:10, gap:8,
  },
  reviewTheme:{ color:TEXT_SEC, fontSize:12, fontWeight:'600', marginTop:2 },
  date:       { color:TEXT_MUTED, fontSize:12, flexShrink:0 },
  content:    { color:TEXT_SEC, fontSize:14, lineHeight:22, marginBottom:10 },
  imageRow:   { marginBottom:10 },
  reviewImg:  { width:80, height:80, borderRadius:8, marginRight:8, backgroundColor:SURFACE2 },
  cardBottom: { flexDirection:'row', justifyContent:'space-between', alignItems:'center' },
  result:     { fontSize:12, fontWeight:'600' },
  deleteBtn:  { flexDirection:'row', alignItems:'center', gap:4, padding:6 },
  deleteBtnText: { color:RED, fontSize:13 },

  ctaBtn:    { marginTop:8 },
  // GradientButton은 세로 패딩만 내장돼 있어(가로폭에 맞춰 늘어나는 용도가 기본) 텍스트에
  // 가로 패딩을 줘서 좁은 중앙 정렬 버튼의 폭을 확보
  ctaBtnTxt: { paddingHorizontal:28 },
});